module.exports = __webpack_public_path__ + "img/web_anzxz_btn.cd625d56.png";